import React, {useReducer, useContext, createContext} from 'react'
import Snackbar from '@material-ui/core/Snackbar';
import { Alert, AlertTitle } from '@material-ui/lab';
import Errors from './Errors'

const ToasterContext = createContext()

const SHOW_MESSAGE = 'SHOW_MESSAGE'
const HIDE_MESSAGE = 'HIDE_MESSAGE'

const initialState = {
  show: false,
  message: null,
  error: null
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_MESSAGE:
        return {
            show: true,
            message: action.payload.message,
            error: action.payload.error
        };
    case HIDE_MESSAGE:
        return initialState;
    default:
        return initialState;
  }
}

export const ToasterProvider = ({children}) => {
  const [state, dispatch]= useReducer(reducer, initialState)
  return (
    <ToasterContext.Provider value={[state, dispatch]}>
      {children}
    </ToasterContext.Provider>
  )
}

export const useToaster = () => {
  const [toasterState, dispatch]= useContext(ToasterContext)

  const showError= (error) => {
    dispatch({type:SHOW_MESSAGE,payload:{error}})
  }
  const showMessage= (message) => {
    dispatch({type:SHOW_MESSAGE,payload:{message}})
  }
  const closeToaster= () => {
    dispatch({type:HIDE_MESSAGE})
  }

  return {showError, showMessage, closeToaster, toasterState}
}

const Toaster = () => {
  const {closeToaster, toasterState:state}= useToaster()
  let error= null
  if (state.error) {
    if (state.error.response && state.error.response.data) {
      error= state.error.response.data
    }
    else if ( state.error.message ) {
      error= { title: state.error.name, message: state.error.message }
    }
    else {
        error= { message: state.error}
    }
  }

  return (
    <Snackbar open={!!error || !!state.message} autoHideDuration={4000} onClose={closeToaster}>
      <Alert onClose={closeToaster} severity={error ? 'error' : 'success'}>
      <AlertTitle>{error ? error.title : null}</AlertTitle>
        {error && <><p>{error.message}</p><Errors errors={error.errors} /></>}
        {state.message && <p>{state.message}</p>}
      </Alert>
    </Snackbar>
  )
}

export default Toaster